// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"ca1b4d7b","263":"c7d57629","532":"488a7eb1","725":"cad2c072"}[chunkId] + ".chunk.js";
};